import gql from 'graphql-tag'
import {
	media as mediaFragment
} from './fragments'

export default gql`
mutation createMedia($required: MediaReqFields!, $fields: MediaFields, $copyId: ID) {
	cashAssist {
	  createMutation: createMedia(required: $required, fields: $fields, copyId: $copyId) {
			id
			mod_ver
			...mediamain
			cashRegisterId
		}
	}
}
${mediaFragment}`
